/** Fogarty's compact, single-row production account menu. */
import Header from "../../../components/base/Header.js";
import { getTheme } from "../../../core/configAccessors.js";

export default class FogartyHeader extends Header {
  _buildLogin() {
    const wrap = super._buildLogin();
    const menu = wrap.querySelector(".ws-login-menu");
    const url = getTheme("account_login_url", null);
    if (!url) return wrap;

    const login = document.createElement("a");
    login.className = "ws-login-item";
    login.href = url;
    login.target = "_blank";
    login.rel = "noopener noreferrer";

    const icon = document.createElement("span");
    icon.className = "ws-fogarty-account-icon";
    icon.setAttribute("aria-hidden", "true");
    icon.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><circle cx="12" cy="8" r="4"/><path d="M5 21v-2a7 7 0 0 1 14 0v2"/></svg>';
    const label = document.createElement("span");
    label.textContent = "Login";
    login.append(icon, label);
    menu.replaceChildren(login);
    return wrap;
  }
}
